import { Modal} from 'antd';

export default function MyModal({title,visible,message, onOk, onCancel}) {
  return (
      <Modal title={title} visible={visible} onOk={onOk} onCancel={onCancel} okText='Ναι' cancelText='Όχι'  maskClosable={false}>
        <p>{message}</p>
      </Modal>
  );
};